var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullLogoTransparentText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1796 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Full_Logo_-_Transparent_Text_svg__clip0_102_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.548 88.372v-20.21h-15.77v20.21h15.77z",
    fill: "#BF9A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.371 87.296V68.962h-12.157v18.334h12.157z",
    fill: "#FFE7AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.389 104.604c-13.673-9.728-13.673-25.502 0-35.231l47.741-33.97c13.673-9.73 35.841-9.73 49.514 0l47.741 33.97c13.673 9.729 13.673 25.502 0 35.231l-47.741 33.97c-13.673 9.729-35.841 9.729-49.514 0l-47.741-33.97z",
    fill: "url(#Full_Logo_-_Transparent_Text_svg__paint0_linear_102_82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.389 86.382c-13.673-9.729-13.673-25.502 0-35.231l47.741-33.97c13.673-9.73 35.841-9.73 49.514 0l47.741 33.97c13.673 9.729 13.673 25.502 0 35.231l-47.741 33.97c-13.673 9.729-35.841 9.729-49.514 0l-47.741-33.97z",
    fill: "#F0CD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.072 170.412v-18.303h-15.86v18.303h15.86z",
    fill: "#BF3B11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.786 170.234v-18.223h-12.217v18.223h12.217z",
    fill: "#FFA284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 187.849c-13.673-9.729-13.673-25.502 0-35.231l47.741-33.97c13.673-9.729 35.841-9.729 49.514 0l47.741 33.97c13.673 9.729 13.673 25.502 0 35.231l-47.741 33.97c-13.673 9.729-35.841 9.729-49.514 0l-47.741-33.97z",
    fill: "url(#Full_Logo_-_Transparent_Text_svg__paint1_linear_102_82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.822 169.627c-13.673-9.729-13.673-25.503 0-35.232l47.741-33.97c13.673-9.728 35.841-9.728 49.514 0l47.741 33.97c13.673 9.729 13.673 25.503 0 35.232l-47.741 33.97c-13.673 9.729-35.841 9.729-49.514 0l-47.741-33.97z",
    fill: "#EB6E46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.099 170.805v-19.399h-15.852v19.399h15.852z",
    fill: "#215050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.81 170.448v-18.642H18.584v18.642H30.81z",
    fill: "#60A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.857 187.849c-13.673-9.729-13.673-25.502 0-35.231l47.742-33.97c13.672-9.729 35.841-9.729 49.513 0l47.742 33.97c13.672 9.729 13.672 25.502 0 35.231l-47.742 33.97c-13.672 9.729-35.84 9.729-49.513 0l-47.742-33.97z",
    fill: "url(#Full_Logo_-_Transparent_Text_svg__paint2_linear_102_82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.857 169.627c-13.673-9.729-13.673-25.503 0-35.232l47.742-33.97c13.672-9.728 35.841-9.728 49.513 0l47.742 33.97c13.672 9.729 13.672 25.503 0 35.232l-47.742 33.97c-13.672 9.729-35.84 9.729-49.513 0l-47.742-33.97z",
    fill: "#3A6E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Full_Logo_-_Transparent_Text_svg__paint0_linear_102_82",
    x1: 308.07,
    y1: 84.598,
    x2: 139.812,
    y2: 26.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#BE9944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#FFE6AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Full_Logo_-_Transparent_Text_svg__paint1_linear_102_82",
    x1: 423.503,
    y1: 167.843,
    x2: 255.245,
    y2: 109.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#BE3B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#FFA284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Full_Logo_-_Transparent_Text_svg__paint2_linear_102_82",
    x1: 192.538,
    y1: 167.843,
    x2: 24.281,
    y2: 109.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#215050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#609F9F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Full_Logo_-_Transparent_Text_svg__clip0_102_82"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1796v239H0z"
  })))));
}

export default SvgFullLogoTransparentText;